import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import * as Icons from "lucide-react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { TRPCClientError } from "@trpc/client";
import { useTRPC } from "@/trpc";

interface Props {
    user_id: string;
    trigger?: React.ReactNode
    onDeleted?: () => void
}

const DeleteUser = ({ user_id, trigger, onDeleted }: Props) => {
    const { trpc } = useTRPC();
    const [open, setOpen] = useState(false);

    const deleteMutation = useMutation({
        mutationFn: async () => {
            await trpc.users.remove.mutate({
                user_id: user_id
            })
        },
        onSuccess: () => {
            setOpen(false)
            onDeleted?.()
        },
        onError: (err) => {
            if(err instanceof Error) {
                toast.error(err.message)
            } else if(err instanceof TRPCClientError) {
                toast.error(err.message)
            } else {
                toast.error("Er is een onbekende fout opgetreden")
            }
        }
    })

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogTrigger asChild>
            {trigger}
        </AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle className="flex items-center gap-2"><Icons.AlertTriangle className="w-4 h-4" /> Verwijderen</AlertDialogTitle>
                <AlertDialogDescription>Weet je zeker dat je deze gebruiker wilt verwijderen?</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>Annuleren</AlertDialogCancel>
                <Button 
                    onClick={()=>{deleteMutation.mutate()}}
                    disabled={deleteMutation.isLoading}
                    variant='destructive'
                >
                    {deleteMutation.isLoading && <Icons.Loader2 className="w-4 h-4 animate-spin" />}
                    Verwijderen
                </Button>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteUser